// ** React Imports
import { lazy } from 'react';

const ReviewRoutes = [
  {
    path: 'reviews',
    component: lazy(() => import('views/reviews/allReviews')),
  },
  {
    path: 'reviews/product',
    component: lazy(() => import('views/reviews/productReviews')),
  },
  {
    path: 'reviews/order',
    component: lazy(() => import('views/reviews/orderReviews')),
  },
  {
    path: 'reviews/details/:id',
    component: lazy(() => import('views/reviews/reviewDetails')),
  },
];

export default ReviewRoutes;
